import React from 'react';
import { useDarkMode } from '../../utils/darkModeContext.js';
import { useLanguage } from '../../utils/languageContext.js';
import { getTranslation } from '../../utils/translate.js';

const DarkModeToggle = () => {
    const { isDarkMode, toggleDarkMode } = useDarkMode();
    const { language } = useLanguage();

    return (
        <button
            onClick={toggleDarkMode}
            className="flex items-center justify-center w-10 h-10 rounded-full bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors duration-200"
            aria-label={isDarkMode ? getTranslation('common.lightMode', language) : getTranslation('common.darkMode', language)}
            title={isDarkMode ? getTranslation('common.lightMode', language) : getTranslation('common.darkMode', language)}
        >
            {isDarkMode ? (
                // Sun icon - click to switch to light mode
                <svg
                    className="w-5 h-5 text-yellow-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                    />
                </svg>
            ) : (
                // Moon icon - click to switch to dark mode
                <svg
                    className="w-5 h-5 text-gray-700"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                    />
                </svg>
            )}
        </button>
    );
};

export default DarkModeToggle;

